import { render, staticRenderFns } from "./OuterPlanking.vue?vue&type=template&id=8bd19bd6&"
import script from "./OuterPlanking.vue?vue&type=script&lang=js&"
export * from "./OuterPlanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports